import { render, staticRenderFns } from "./ReadRecord.vue?vue&type=template&id=5543b9b0&scoped=true"
import script from "./ReadRecord.vue?vue&type=script&lang=js"
export * from "./ReadRecord.vue?vue&type=script&lang=js"
import style0 from "./ReadRecord.vue?vue&type=style&index=0&id=5543b9b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5543b9b0",
  null
  
)

export default component.exports